export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "Login failed, please try again.",
  requestFailed: "Request failed, please check your internet connection.",
  invalidLogin: "Invalid Username or Password.",
  thisFunctionExists: "This function is already exists.",
  thisFunctionNotAllowDelete: "This function is not allow to delete.",
  thisFunctionNotExists: "This function is not exists.",
  targetFunctionIdRequired: "Target Function ID is required.",
  thisPageExists: "This page is already exists.",
  thisPageNotAllowDelete: "This page is not allow to delete.",
  thisRoleExists: "This role is already exists.",
  thisRoleNotAllowDelete: "This role is not allow to delete.",
  targetRoleIdRequired: "Target Role ID is required.",
  invalidParameter: "Invalid Parameter.",
  systemError: "System unable to process your request.",
  spErrorMessage: "SP Message Error (Depend what error).",
  actionbyRequired: "Current User is required.",
  sessionTokenRequired: "Session Token is required.",
  functionIdRequired: "Function ID is required.",
  functionNameRequired: "Function name is required.",
  newFunctionNameRequired: "Function name is required.",
  pageIdRequired: "Page ID is required.",
  newPageIdRequired: "Page ID is required.",
  newPageNameRequired: "Page name is required.",
  targetPageIdRequired: "Target Page ID is required.",
  passwordRequired: "Password is required.",
  userNameRequired: "Full Name is required.",
  passwordValidation: "Password must be 6-20 characters and a combination of number(s) and letter(s).",
  pageNumRequired: "Page Number is required.",
  pageSizeRequired: "Page Size is required.",
  roleIdRequired: "Role ID is required",
  oldPasswordRequired: "Current Password is required.",
  userStatusRequired: "User Status is required.",
  newRoleIdRequired: "Role ID is required.",
  newRoleNameRequired: "Role Name is required.",
  startDateIsGteEndDate: "Start Date is greater than End Date.",
  thisRoleNotExists: "This Role is not exists.",
  thisPageNotExists: "This Page is not exists.",
  thisUserExists: "This User is already exists.",
  thisUserNotExists: "This User is not exists.",
  thisUserBlackListed: "Your account has been suspended.",
  thisUserInactive: "Your account has been disabled.",
  thisUserBlocked: "Your account has been blocked.",
  thisUserNotActive: "Your account has been disabled.",
  InvalidPageFunction: "Invalid Page Function.",
  invalidUser: "Invalid User!",
  invalidToken: "Invalid Session!",
  NoUserAccessRight: "Permission Denied!",
  connection: "Connection Error",
  profileIdRequired: "Profile ID is required.",
  packageIdRequired: "Package ID is required.",
  fullNameMinThreeChar: "Full name must have at least 3 characters.",
  accountIdMinThreeChar: "Account ID must have at least 3 characters.",
  searchCriteriaRequired: "Search criteria is required.",
  affiliateIdRequired: "Affiliate ID is required.",
  minDepositRequired: "Min Deposit is required.",
  bonusRateRequired: "Bonus Rate is required.",
  onlyAllowRejectDeposit: "Only allow to reject deposit ticket.",
  senderBankIdRequired: "Sender bank ID is required.",
  senderBankAccNoRequired: "Sender bank acc no. is required.",
  minFTDAmtNumOnly: "Min. FTD Amt accept only numerics.",
  maxFTDAmtNumOnly: "Max. FTD Amt accept only numerics.",
  crmBasicCriteriaRequired: "Member ID / Contact Phone / Contact Email / Signup Date / Last Login Date is required.",
  verifiedDateRangeAllowThreeMonths: "Signup date range only allow select up to 3 months.",
  lastLoginDateRangeAllowThreeMonths: "Last Login date range only allow select up to 3 months.",
  depositDateRangeAllowThreeMonths: "Deposit date range only allow select up to 3 months.",
  ftdDateRangeAllowThreeMonths: "FTD date range only allow select up to 3 months.",
  ltdDateRangeAllowThreeMonths: "LTD date range only allow select up to 3 months.",
  lastLoginDateEarlierThanVerifiedDate: "Last Login date earlier than signup date.",
  depositDateEarlierThanVerifiedDate: "Deposit date earlier than signup date.",
  ftdDateEarlierThanVerifiedDate: "FTD date earlier than signup date.",
  ltdDateEarlierThanVerifiedDate: "LTD date earlier than signup date.",
  ftdFromRequired: "FTD from date is required.",
  ftdToRequired: "FTD to date is required.",
  ltdFromRequired: "LTD from date is required.",
  ltdToRequired: "LTD to date is required.",
  failedToLaunchPaymentGateway: "Failed to launch payment gateway.",
  enTitleRequired: "EN Title is required.",
  enBodyRequired: "EN Body is required.",
  enImageUrlRequired: "EN Image Url is required.",
  enImageUrlDesktopRequired: "EN Desktop Image Url is required.",
  enAltRequired: "EN Alt is required.",
  enHrefRequired: "EN Href is required.",
  resubmitTicketRequired: "Resubmit ticket is required.",
  withtholdBonusAndAmountGreaterThanZero: "Withhold bonus and withhold amount cannot greater than zero at the same time.",
  maxWithdrawMultipleAndAmountGreaterThanZero: "Max withdraw multiple and max withdraw amount cannot greater than zero at the same time.",
  serverBusy: "Server is busy now. Please try again.",
  isRequired: "Please enter a {fname}.",
  isMinValue: "{fname} must have minimal of {fvalue}.",
  isMaxValue: "{fname} must be less than or equal to {fvalue}.",
  isMinLength: "{fname} must have at least {fvalue} characters.",
  isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
  isAlpha: "{fname} accept only alphabet.",
  isAlphaNum: "{fname} accept only alphanumerics.",
  isNumeric: "{fname} accept only numerics.",
  isEmail: "{fname} accept only valid email addresses.",
  isIpAddress: "{fname} accept only valid IPv4 addresses.",
  isSameAs: "{fname} must be same as {fname2}.",
  isUrl: "{fname} accept only URLs.",
  containAlphaNum: "{fname} must have at least one alphabet and one number.",
  alphaNumWithSpace: "{fname} accept only alphanumerics.",
  isDecimal: "{fname} accept only numerics.",
  isInteger: "{fname} accept only integer.",
  selectOption: "Please select a {fname}",
  notSameAs: "{fname} and {fname2} cannot be the same.",
  dateRangeAllowOneMonth: "Date range only allow select up to 1 month.",
  dateRangeAllowOneYear: "Date range only allow select up to 1 year.",
  greaterThanZero: "{fname} must be greater than zero.",
  atLeastOneAuthority: "Must select at least one authority.",
  BLOCK: "Your account has been blocked.",
  SUSPEND: "Your account has been suspended.",
  CLOSE: "Your account has been closed.",
  RESETL: "Your account has been reset.",
  atLeastOneProvider: "Must select at least one provider.",
  failedToGetResultUrl: "Failed to get result url.",
  fileSizeValidation: "Too large, max size allowed is 1mb",
  atLeastOnePaymentOption: "Must select at least one payment option.",
  atLeastOnePaymentGateway: "Must select at least one payment gateway.",
  dateRangeAllow31Days: "Date range only allow select up to 31 days.",
  dateRangeAllow31Months: "Date range only allow select up to 31 months.",
  dateRangeAllow31Years: "Date range only allow select up to 31 years.",
  invalidCategory: "Invalid category.",
  noChanges: "No changes.",
  permissionDenied: "Permission denied.",
  referralCodeRequired: "Referral code is required.",
  providerDescRequired: "Provider description is required.",
  marqueeContentRequired: "Marquee content is required.",
  bonusNameRequired: "Bonus name is required.",
  baseAmountRequired: "Base amount is required.",
  reviewIdRequired: "Review ID is required.",
  surveyIdRequired: "Survey ID is required.",
  questionRequired: "Question is required.",
  iframeIdRequired: "Iframe ID is required.",
  bonusAmountRequired: "Bonus amount is required.",
  inboxIdRequired: "Inbox ID is required.",
  exchangedAmountRequired: "Exchanged amount is required.",
  baseRateRequired: "Base rate is required.",
  exchangeRateRequired: "Exchange rate is required.",
  baseCurrencyRequired: "Base currency is required.",
  exchangeCurrencyRequired: "Exchange currency is required.",
  depositTypeRequired: "Deposit type is required.",
  nbRedepositRequired: "Nb redeposit is required.",
  bankOwnerRequired: "Bank owner is required.",
  autoSenderRequired: "Auto sender is required.",
  isRecommendRequired: "Is recommend is required.",
  recipientBankIdRequired: "Recipient bank ID is required.",
  recipientBankAccNoRequired: "Recipient bank account number is required.",
  accountBalanceRequired: "Account balance is required.",
  incomingAmountThresholdRequired: "Incoming amount threshold is required.",
  incomingFrequencyThresholdRequired: "Incoming frequency threshold is required.",
  outgoingAmountThresholdRequired: "Outgoing amount threshold is required.",
  outgoingFrequencyThresholdRequired: "Outgoing frequency threshold is required.",
  bankAccTypeRequired: "Bank account type is required.",
  packageRequired: "Package is required.",
  rtpRequired: "RTP is required.",
  domainIdRequired: "Domain ID is required.",
  buyOnBehalfRequired: "Buy on behalf is required.",
  serviceProviderRequired: "Service provider is required.",
  serverAccountRequired: "Server account is required.",
  nameServerRequired: "Name server is required.",
  socialLinkRequired: "Social link is required.",
  newSocialPlatformRequired: "New social platform is required.",
  attachmentPathRequired: "Attachment path is required.",
  depositMethodRequired: "Deposit method is required.",
  depositDateRequired: "Deposit date is required.",
  refNoRequired: "Reference number is required.",
  withdrawalAmountRequired: "Withdrawal amount is required.",
  targetBankAccNoRequired: "Target bank account number is required.",
  targetBankIdRequired: "Target bank ID is required.",
  jsonRatingRequired: "JSON rating is required.",
  startTimeRequired: "Start time is required.",
  accountIdRequired: "Account ID is required.",
  parentIdRequired: "Parent ID is required.",
  amountRequired: "Amount is required.",
  clientIpRequired: "Client IP is required.",
  auditByRequired: "Audit by is required.",
  systemTypeRequired: "System type is required.",
  currencyRequired: "Currency is required.",
  ipAddressRequired: "IP address is required.",
  affiliateCodeRequired: "Affiliate code is required.",
  contactPhoneRequired: "Contact phone is required.",
  requestTypeRequired: "Request type is required.",
  securityDisabledRequired: "Security disabled is required.",
  gameCodeRequired: "Game code is required.",
  seqRequired: "Sequence is required.",
  minLimitRequired: "Minimum limit is required.",
  maxLimitRequired: "Maximum limit is required.",
  commSportsRequired: "Commission for sports is required.",
  commSlotsRequired: "Commission for slots is required.",
  commLivecasinoRequired: "Commission for live casino is required.",
  commCockfightRequired: "Commission for cockfight is required.",
  commOthersRequired: "Commission for others is required.",
  settingValueRequired: "Setting value is required.",
  vipIdRequired: "VIP ID is required.",
  carryOverRequired: "Carry over is required.",
  campaignIdRequired: "Campaign ID is required.",
  titleRequired: "Title is required.",
  bodyRequired: "Body is required.",
  itemOrderRequired: "Item order is required.",
  imageUrlRequired: "Image URL is required.",
  bannerIdRequired: "Banner ID is required.",
  directionRequired: "Direction is required.",
  defaultOrderRequired: "Default order is required.",
  altRequired: "Alt text is required.",
  hrefRequired: "Href is required.",
  targetWindowRequired: "Target window is required.",
  loginRequiredRequired: "Login required is required.",
  activeFromRequired: "Active from is required.",
  activeToRequired: "Active to is required.",
  bannerTypeRequired: "Banner type is required.",
  pageNameRequired: "Page name is required.",
  remarkRequired: "Remark is required.",
  settingKeyRequired: "Setting key is required.",
  memberListRequired: "Member list is required.",
  memberIdRequired: "Member ID is required.",
  workingMonthRequired: "Working month is required.",
  workingDateRequired: "Working date is required.",
  tacRequired: "Terms and conditions is required.",
  paymentModeRequired: "Payment mode is required.",
  newPasswordRequired: "New password is required.",
  loginIdRequired: "Login ID is required.",
  securityTagRequired: "Security tag is required.",
  securityCodeRequired: "Security code is required.",
  providerCodeRequired: "Provider code is required.",
  startDateRequired: "Start date is required.",
  endDateRequired: "End date is required.",
  searchIdRequired: "Search ID is required.",
  authTokenRequired: "Auth token is required.",
  newStatusRequired: "New status is required.",
  actionRequired: "Action is required.",
  promotionIdRequired: "Promotion ID is required.",
  promotionNameRequired: "Promotion name is required.",
  rolloverRequired: "Rollover is required.",
  criteriaRequired: "Criteria is required.",
  ticketIdRequired: "Ticket ID is required.",
  resultIdRequired: "Result ID is required.",
  bankIdRequired: "Bank ID is required.",
  bankAccNoRequired: "Bank account number is required.",
  bankAccHolderRequired: "Bank account holder is required.",
  newBankIdRequired: "New bank ID is required.",
  newBankAccNoRequired: "New bank account number is required.",
  newBankAccHolderRequired: "New bank account holder is required.",
  fullNameRequired: "Full name is required.",
  depositAmountRequired: "Deposit amount is required.",
  gatewayAccRequired: "Gateway account is required.",
  labelNameRequired: "Label name is required.",
  labelIdRequired: "Label ID is required.",
  bankTypeRequired: "Bank type is required.",
  amountLimitRequired: "Amount limit is required.",
  currencyRateRequired: "Currency rate is required.",
  urlRequired: "URL is required.",
  cashRequired: "Cash is required.",
  csRequired: "Customer support is required.",
  vipNameRequired: "VIP name is required.",
  campaignNameRequired: "Campaign name is required.",
  transferIdRequired: "Transfer ID is required.",
  betTimeRequired: "Bet time is required.",
  turnoverRequired: "Turnover is required.",
  payoutRequired: "Payout is required.",
  winloseRequired: "Win/Lose is required.",
  rawMessageRequired: "Raw message is required.",
  authStatusRequired: "Auth status is required.",
  dateRequired: "Date is required.",
  betIdRequired: "Bet ID is required.",
  betStatusRequired: "Bet status is required.",
  betAmountRequired: "Bet amount is required.",
  isParlayRequired: "Is parlay is required.",
  isAddonRequired: "Is addon is required.",
  withholdBonusRequired: "Withhold bonus is required.",
  withholdAmountRequired: "Withhold amount is required.",
  maxWithdrawAmountRequired: "Maximum withdraw amount is required.",
  betTypeRequired: "Bet type is required.",
  maxWithdrawMultipleRequired: "Max withdraw multiple is required.",
  socialPlatformRequired: "Social platform is required.",
  vipProviderRebateRequired: "VIP provider rebate is required.",
  selfRebateRateRequired: "Self rebate rate is required.",
  downlineRebateRateRequired: "Downline rebate rate is required.",
  tierIdRequired: "Tier ID is required.",
  rebateRateRequired: "Rebate rate is required.",
  paymentGatewayRequired: "Payment gateway is required.",
  rescueIdRequired: "Rescue ID is required.",
  rescueNameRequired: "Rescue name is required.",
  rescueCycleRequired: "Rescue cycle is required.",
  minLoseRequired: "Minimum lose is required.",
  rescueRateRequired: "Rescue rate is required.",
  maxPayoutRequired: "Maximum payout is required.",
  payoutMethodRequired: "Payout method is required.",
  targetGroupRequired: "Target group is required.",
  maintainDepositRequired: "Maintain deposit is required.",
  maintainTurnoverRequired: "Maintain turnover is required.",
  depositOrTurnoverRequired: "Deposit or turnover is required.",
  maintainDepositOrMaintainTurnoverRequired: "Maintain deposit or maintain turnover is required.",
  vipListRequired: "VIP list is required.",
  gameNameRequired: "Game name is required.",
  claimTypeRequired: "Claim type is required.",
  operatorIdRequired: "Operator ID is required.",
  maxBonusRequired: "Max bonus is required.",
  endTimeRequired: "End time is required.",
  mondayRequired: "Monday is required.",
  tuesdayRequired: "Tuesday is required.",
  wednesdayRequired: "Wednesday is required.",
  thursdayRequired: "Thursday is required.",
  fridayRequired: "Friday is required.",
  saturdayRequired: "Saturday is required.",
  sundayRequired: "Sunday is required.",
  promotionTypeRequired: "Promotion type is required.",
  claimLimitRequired: "Claim limit is required.",
  bonusRate1Required: "Bonus rate 1 is required.",
  bonusRate1To2Required: "Bonus rate 1 to 2 is required.",
  bonusRate1To3Required: "Bonus rate 1 to 3 is required.",
  bonusRate1To4Required: "Bonus rate 1 to 4 is required.",
  bonusRate1To5Required: "Bonus rate 1 to 5 is required.",
  bonusRate1To6Required: "Bonus rate 1 to 6 is required.",
  bonusRate1To7Required: "Bonus rate 1 to 7 is required.",
  externalIdRequired: "External ID is required.",
  opsiteRequired: "Opsite is required.",
  opsiteContentRequired: "Opsite content is required.",
  opsiteLanguageRequired: "Opsite language is required.",
  opsitePaymentRequired: "Opsite payment is required.",
  opsiteProviderRequired: "Opsite provider is required.",
  opsiteProviderGamesRequired: "Opsite provider games is required.",
  accountTypeRequired: "Account type is required.",
  domainNameRequired: "Domain name is required.",
  settledTimeRequired: "Settled time is required.",
  validTurnoverRequired: "Valid turnover is required.",
  resultTimeRequired: "Result time is required.",
  resultStatusRequired: "Result status is required.",
  secondIdRequired: "Second ID is required.",
  domainListRequired: "Domain list is required.",
  domainTypeRequired: "Domain type is required.",
  moduleRequired: "Module is required.",
  gameIdRequired: "Game ID is required.",
  gameDetailRequired: "Game detail is required.",
  bonusRate1To8Required: "Bonus rate 1 to 8 is required.",
  bonusRate1To9Required: "Bonus rate 1 to 9 is required.",
  bonusRate1To10Required: "Bonus rate 1 to 10 is required.",
  invalidOrder: "Invalid order.",
  bannerNotExists: "Banner does not exist.",
  invalidBannerType: "Invalid banner type.",
  pageNameExists: "Page name exists.",
  pageNotExists: "Page does not exist.",
  tacIsValid: "OTP is valid.",
  invalidTac: "Invalid OTP.",
  tacExpired: "OTP expired.",
  tacNotValidate: "OTP not validated.",
  paymentModeNotExists: "Payment mode does not exist.",
  paymentOptionProviderNotExists: "Payment option provider does not exist.",
  ipAddressExists: "IP address exists.",
  ticketProcessed: "Ticket processed.",
  bankAccountNotExists: "Bank account does not exist.",
  bankAccountInactive: "Bank account inactive.",
  bankMemberNotExists: "Bank member does not exist.",
  bankMemberInactive: "Bank member inactive.",
  affiliateExists: "Affiliate exists.",
  contactPhoneExists: "Contact phone exists.",
  affiliateFull: "Affiliate full.",
  uplineInactive: "Upline inactive.",
  applicationProcessed: "Application processed.",
  tacValidated: "Terms and conditions validated.",
  applicationPending: "Application pending.",
  favouriteGameExists: "Favorite game exists.",
  invalidLimit: "Invalid limit.",
  settingNotSet: "Setting not set.",
  domainNameNotExists: "Domain name does not exist.",
  domainNameFull: "Domain name full.",
  domainNameNotAvailable: "Domain name not available.",
  domainNameExists: "Domain name exists.",
  subAccountNotExists: "Sub-account does not exist.",
  settingNotExists: "Setting does not exist.",
  invalidContactEmail: "Invalid contact email.",
  accountInactive: "Account is inactive.",
  campaignNotExists: "Campaign does not exist.",
  paymentProviderNotExists: "Payment provider does not exist.",
  profileInactive: "Profile inactive.",
  minWithdrawalNotMet: "Minimum withdrawal not met.",
  invalidBankId: "Invalid bank ID.",
  bankAccountExists: "Bank account exists.",
  bankAccountFull: "Bank account full.",
  bankAccHolderNotSame: "Bank account holder not the same.",
  exceedMaxWithdrawal: "Exceeds maximum withdrawal.",
  exceedWithdrawalFrequency: "Exceeds withdrawal frequency.",
  invalidPackage: "Invalid package.",
  promotionNotAvailable: "Promotion not available.",
  ongoingPromotion: "Ongoing promotion.",
  pendingResultInGame: "Pending result in game.",
  labelNameExists: "Label name exists.",
  labelNotExists: "Label does not exist.",
  invalidFtdMin: "Invalid first-time deposit minimum.",
  invalidFtdMax: "Invalid first-time deposit maximum.",
  ftdMinGtFtdMax: "First-time deposit minimum greater than maximum.",
  vipFull: "VIP full.",
  invalidRewardType: "Invalid reward type.",
  vipExists: "VIP exists.",
  vipNotExists: "VIP does not exist.",
  onlyOneMaxWithdrawSetting: "Only one maximum withdraw setting allowed.",
  onlyOneWithholdSetting: "Only one withhold setting allowed.",
  campaignExists: "Campaign exists.",
  vipProviderNotExists: "VIP provider does not exist.",
  turnoverTierExists: "Turnover tier exists.",
  turnoverTierFull: "Turnover tier exceeds maximum tier.",
  turnoverTierNotExists: "Turnover tier does not exist.",
  invalidSettingValue: "Invalid setting value.",
  turnoverTierNotSet: "Turnover tier not set.",
  rebateProcessed: "Rebate processed.",
  invalidActionType: "Invalid action type.",
  invalidRescueCycle: "Invalid rescue cycle.",
  invalidPayoutMethod: "Invalid payout method.",
  invalidTargetGroup: "Invalid target group.",
  rescueExists: "Rescue exists.",
  rescueNotExists: "Rescue does not exist.",
  walletExists: "Wallet exists.",
  accountExists: "Account exists.",
  activeFromGtActiveTo: "Active from greater than active to.",
  accountNotExists: "Operator ID does not exist.",
  invalidDeposit: "Invalid deposit.",
  invalidTurnover: "Invalid turnover.",
  providerCodeNotExists: "Provider code does not exist.",
  gameNameExists: "Game name exists.",
  gameNameNotExists: "Game name does not exist.",
  invalidAccountType: "Invalid account type.",
  invalidLoginIdFormat: "Invalid login ID format.",
  invalidReferralCode: "Invalid referral code.",
  firstDepositNotMet: "First deposit not met.",
  newbieNotMet: "Newbie requirements not met.",
  claimPromoOnlyOnce: "Claim promotion only once.",
  promotionRequirementNotMet: "Promotion requirement not met.",
  withdrawalAmountLteWithholdAmount: "Withdrawal amount less than or equal to withhold amount.",
  subAccountInactive: "Sub-account inactive.",
  gameNotSupported: "Game not supported.",
  startTimeGteEndTime: "Start time greater than or equal to end time.",
  invalidPromotionType: "Invalid promotion type.",
  invalidClaimType: "Invalid claim type.",
  claimLimitExceeded10: "Claim limit exceeded 10.",
  verificationFailed: "Verification failed.",
  claimLimitReached: "Claim limit reached.",
  invalidPromotion: "Invalid promotion.",
  socialPlatformExists: "Social platform exists.",
  duplicateReview: "Duplicate review.",
  invalidSurveyId: "Invalid survey ID.",
  accountNotBlock: "Account not blocked.",
  walletNotExists: "Wallet does not exist.",
  socialPlatformNotExists: "Social platform does not exist.",
  socialPlatformInactive: "Social platform inactive.",
  accountSocialExists: "Social Account exists.",
  invalidStatus: "Invalid status.",
  samePassword: "Same password.",
  invalidPassword: "Invalid Username or Password.",
  secondaryAccountExists: "Secondary account exists.",
  invalidSecurityCode: "Invalid security code.",
  accountSocialNotExists: "Account social does not exist.",
  providerInactive: "Provider inactive.",
  gameIdExists: "Game ID exists.",
  gameIdNotExists: "Game ID does not exist.",
  parentProviderInactive: "Parent provider inactive.",
  betLimitNotExists: "Bet limit does not exist.",
  min3Characters: "Minimum 3 characters.",
  invalidBankAccType: "Invalid bank account type.",
  senderBankNotExists: "Sender bank does not exist.",
  recipientBankNotExists: "Recipient bank does not exist.",
  affiliateNotExists: "Affiliate does not exist.",
  redepositedTicket: "Redeposited ticket.",
  invalidDepositType: "Invalid deposit type.",
  affiliateInactive: "Affiliate inactive.",
  bonusUnavailable: "Bonus unavailable.",
  pendingDeposit: "Pending deposit.",
  noOngoingPromotion: "No ongoing promotion.",
  iframeNotExists: "IFrame does not exist.",
  gameMaintenance: "Game maintenance.",
  labelInactive: "Label inactive.",
  invalidDomainType: "Invalid domain type.",
  invalidModule: "Invalid module.",
  labelFull: "Label full.",
  questionExists: "Question exists.",
  questionFull: "Question full.",
  questionNotExists: "Question does not exist.",
  reviewNotExists: "Review does not exist.",
  invalidDomainGroup: "Invalid domain group.",
  invalidDateRange: "Invalid date range.",
  ipAddressNotExists: "IP address does not exist.",
  marqueeNotExists: "Marquee does not exist.",
  invalidAmount: "Invalid amount.",
  insufficientBalance: "Insufficient balance.",
  minLimitLtParent: "Minimum limit less than parent.",
  maxLimitGtParent: "Maximum limit greater than parent.",
  startDateGtEndDate: "Start date greater than end date.",
  currencyNotExists: "Currency does not exist.",
  currencyExists: "Currency exists.",
  noAccumulateWin: "No accumulated win.",
  invalidSession: "Invalid session.",
  sessionExpired: "Session expired.",
  promotionExists: "Promotion exists.",
  invalidCriteria: "Invalid criteria.",
  promotionNotExists: "Promotion does not exist.",
  ticketNotExists: "Ticket does not exist.",
  duplicateDebitRecord: "Duplicate debit record.",
  duplicateCreditRecord: "Duplicate credit record.",
  debitRecordNotExists: "Debit record does not exist.",
  minDepositNotMet: "Minimum deposit not met.",
  duplicateBet: "Duplicate bet.",
  invalidProviderCode: "Invalid provider code.",
  resultExists: "Result exists.",
  unableSPProcess: "System unable to process your request.",
  authRequired: "Authentication code is required.",
  domainExists: "Domain already exists.",
  multiSelectOption: "Please select {fname}",
  invalidDomainFormat: "Invalid Domain Format",
  noHttpHttps: "'https://' or 'http://' is not allowed.",
  noReservedSubdomain: "Reserved subdomain is not allowed. For app download link usage.",
  operatorInactive: "Operator is inactive",
  invalidAccountIdFormat: "Invalid Account ID format",
  contentIdRequired: "Menu ID is required",
  themeCodeRequired: "Theme code is required",
  themeNameRequired: "Theme name is required",
  themeColorRequired: "Theme color is required",
  languageRequired: "Language is required",
  positionRequired: "Position is required",
  themeContentIdRequired: "Theme content ID is required",
  emailRequired: "Email is required",
  themeProviderTypeRequired: "Theme provider type is required",
  phoneRequired: "Phone is required",
  targetTypeRequired: "Target type is required",
  packageTypeRequired: "Package type is required",
  renewTermRequired: "Renew term is required",
  packagePriceRequired: "Package price is required",
  packageStatusRequired: "Package status is required",
  sortKeyRequired: "Sort key is required",
  invalidDomainStatus: "Invalid domain status",
  invalidCurrency: "Invalid currency",
  invalidThemeCode: "Invalid theme code",
  invalidLanguage: "Invalid language",
  invalidPosition: "Invalid position",
  invalidThemeContent: "Invalid theme content",
  allParamsSameAsCurrent: "There are no changes",
  invalidThemeColor: "Invalid theme color",
  invalidCartStatus: "Invalid cart status",
  invalidThemeProviderType: "Invalid theme provider type",
  themeProviderTypeCannotBeUse: "Theme provider type cannot be used",
  invalidUserStatus: "Invalid user status",
  packageCannotBeRemove: "Package cannot be removed",
  userStatusIsAlrdSuspend: "User is already suspended",
  userStatusIsAlrdBlocked: "User is already blocked",
  userStatusIsAlrdActive: "User is already active",
  invalidSortType: "Invalid sort type",
  startDateBiggerThanEndDate: "Start date is bigger than end date",
  positionCannotBeUse: "Position cannot be used",
  funcAddContentFailed: "Failed to add content",
  funcDeleteContentFailed: "Failed to delete content",
  funcUpdateContentFailed: "Failed to update content",
  funcAddThemeFailed: "Failed to add theme",
  funcDeleteThemeFailed: "Failed to delete theme",
  funcUpdateThemeFailed: "Failed to update theme",
  funcAddThemeColorFailed: "Failed to add theme color",
  funcDeleteThemeColorFailed: "Failed to delete theme color",
  funcUpdateThemeColorFailed: "Failed to update theme color",
  funcAddLanguageFailed: "Failed to add language",
  funcDeleteLanguageFailed: "Failed to delete language",
  funcUpdateLanguageFailed: "Failed to update language",
  funcAddThemeContentFailed: "Failed to add theme content",
  funcDeleteThemeContentFailed: "Failed to delete theme content",
  funcUpdateThemeContentFailed: "Failed to update theme content",
  funcAddContentPositionFailed: "Failed to add content position",
  funcUpdateContentPositionFailed: "Failed to update content position",
  funcDeleteContentPositionFailed: "Failed to delete content position",
  funcAddThemeProviderTypeFailed: "Failed to add theme provider type",
  funcUpdateThemeProviderTypeFailed: "Failed to update theme provider type",
  funcDeleteThemeProviderTypeFailed: "Failed to delete theme provider type",
  funcAddPackageFailed: "Failed to add package",
  funcUpdatePackageFailed: "Failed to update package",
  funcDeletePackageFailed: "Failed to delete package",
  nicknameRequired: "Nickname is required",
  accountStatusRequired: "Account status is required",
  contentIdMaxLength50: "Menu ID maximum length is 50",
  positionMaxLength10: "Position maximum length is 10",
  contentDescMaxLength200: "Content description maximum length is 200",
  domainStatusRequired: "Domain status is required",
  funcAddDomainFailed: "Failed to add domain",
  funcUpdateDomainFailed: "Failed to update domain",
  uploadFailed: "Uploading failed!",
  sortKeyMaxLength50: "Sort key max length is 50",
  invalidSortTypeFormat: "Invalid sort type format",
  invalidPackageId: "Invalid package ID",
  invalidAccountStatusFormat: "Invalid account status format",
  invalidSiteStatusFormat: "Invalid site status format",
  invalidPackageStatus: "Invalid package status",
  invalidEmailFormat: "Invalid email format",
  invalidPhoneFormat: "Invalid phone format",
  languageLengthNotInRange: "Language length not in range (2-5)",
  languageDescriptionMaxLength50: "Language description max length is 50",
  remarkMaxLength500: "Remark max length is 500",
  themeProviderTypeMaxLength50: "Theme provider type max length is 50",
  themeNameMaxLength50: "Theme name max length is 50",
  themeColorMaxLength20: "Theme color max length is 20",
  noSpace: "Must not contain space",
  packageDescEnRequired: "Name English is required",
  packageDescEnMaxLength20: "Name English max length is 20",
  allParamsIsNull: "All parameters are null",
  contentCannotBeRemove: "Content cannot be removed",
  contentDetailsRequired: "Content details are required",
  domainCannotBeUse: "Domain cannot be used",
  domainGroupMaxLength20: "Domain group max length is 20",
  domainGroupRequired: "Domain group is required",
  domainNameCannotUpdate: "Domain name cannot be updated",
  domainNameMaxLength400: "Domain name max length is 400",
  domainsRequired: "Domains are required",
  domainStatusMaxLength20: "Domain status max length is 20",
  domainTypeMaxLength10: "Domain type max length is 10",
  funcAddThemeContentGroupFailed: "Add theme content group failed",
  funcDeleteThemeContentGroupFailed: "Delete theme content group failed",
  funcOpsiteUpdateFailed: "Opsite update failed",
  funcResetAccountPasswordFailed: "Reset account password failed",
  funcSiteLanguageUpsertFailed: "Site language upsert failed",
  funcSiteThemeContentUpsertFailed: "Site theme content upsert failed",
  funcSiteThemeUpsertFailed: "Site theme upsert failed",
  funcSiteUpdateFailed: "Site update failed",
  funcUpdateAccountFailed: "Update account failed",
  funcUpdateAccountStatusActiveFailed: "Update account status to active failed",
  funcUpdateAccountStatusCompanyBlockFailed: "Update account status to company block failed",
  funcUpdateAccountStatusSuspendFailed: "Update account status to suspend failed",
  funcUpdateThemeContentGroupFailed: "Update theme content group failed",
  invalidBoDomain: "Invalid BO domain",
  invalidOperatorIdFormat: "Invalid operator ID format",
  invalidOpsite: "Invalid opsite",
  invalidOpsiteOperator: "Invalid opsite operator",
  invalidOpsiteVersion: "Invalid opsite version",
  invalidParentContentInGroup: "Invalid parent content in group",
  invalidSite: "Invalid site",
  invalidSiteStatus: "Invalid site status",
  invalidThemeContentGroup: "Invalid theme content group",
  languageCannotBeUse: "Language cannot be used",
  languagesRequired: "Languages are required",
  logo1Required: "Logo is required",
  notSupportMultiDefault: "Multi-default is not supported",
  operatorIdMaxLength50: "Operator ID max length is 50",
  opsiteNotMatch: "Opsite does not match",
  packageTypeMaxLength15: "Package type max length is 15",
  parentContentIdCannotSameWithContentId: "Parent content ID cannot be the same as content ID",
  phoneNumberRequired: "Phone number is required",
  siteIdRequired: "Site ID is required",
  siteNameMaxLength50: "Site name max length is 50",
  siteNameRequired: "Site name is required",
  technicalError: "Technical error",
  themeCannotBeRemove: "Theme cannot be removed",
  themeCodeCannotBeUse: "Theme code cannot be used",
  themeCodeMaxLength20: "Theme code max length is 20",
  themeColorCannotBeRemove: "Theme color cannot be removed",
  themeColorCannotBeUse: "Theme color cannot be used",
  themeContentCannotBeUse: "Theme content cannot be used",
  themeContentGroupCannotBeUse: "Theme content group cannot be used",
  themeContentGroupDescriptionMaxLength50: "Theme content group description max length is 50",
  themeContentGroupMaxLength20: "Theme content group max length is 20",
  themeContentGroupRequired: "Theme content group is required",
  themeNameCannotBeUse: "Theme name cannot be used",
  userHaventVerifyThisBefore: "User hasn't verified this before",
  isDefaultTrueRequired: "Language must have 1 default",
  accountIdMaxLength50: "User ID max length is 50",
  headBodyScriptEitherOne: "Please enter Head Script or Body Script",
  alphaOrNum: "Must be alphabet or numbers only",
  phoneValid: "Please enter a valid Phone Number",
  permittedAmountRequired: "Permitted amount is required",
  ignoreRiskRequired: "Ignore risk is required",
  paymentDescRequired: "Payment description is required",
  gameTypeRequired: "Game type is required",
  statusRequired: "Status is required",
  payoutIdRequired: "Payout Id is required",
  commNotExists: "Commission not exists",
  parentCommNotExists: "Parent commission not exists",
  carryOverNotExists: "Carry over not exists",
  hotGameExists: "Hot game is already exists",
  commSportsExceededParent: "Commission for sports exceeded parent",
  commSlotsExceededParent: "Commission for slots exceeded parent",
  commLivecasinoExceededParent: "Commission for live casino exceeded parent",
  commCockfightExceededParent: "Commission for cockfight exceeded parent",
  commOthersExceededParent: "Commission for others exceeded parent",
  hotGameNotExists: "Hot game not exists",
  noSecurityDeposit: "No security fund",
  exchangeRateNotExists: "Exchange rate not exists",
  insufficientSecurityDeposit: "Insufficient security fund",
  duplicateDomain: "Duplicate domain",
  contactEmailNotExists: "Contact email not exists",
  featuredGameNotExists: "Feature game not exists",
  newGameNotExists: "New game not exists",
  popularGameNotExists: "Popular game not exists",
  featuredGameExists: "Feature game is already exists",
  newGameExists: "New game is already exists",
  popularGameExists: "Popular game is already exists",
  rebateNotExists: "Rebate not exists",
  riskyMember: "Risky member",
  ipRestricted: "IP restricted",
  notSupportedBank: "Not supported bank.",
  requestTooFrequent: "Request is too frequent.",
  paymentOptionNotExists: "Payment Option not exists.",
  earningIdRequired: "Earning ID required.",
  ptOnRequired: "PT on required.",
  ptRequired: "PT required.",
  userIdRequired: "User ID required.",
  businessIdRequired: "Business ID required.",
  subAccountIdRequired: "Sub Account ID required.",
  sourceAccountIdRequired: "Source Account ID required.",
  targetAccountIdRequired: "Target Account ID required.",
  ticketTaken: "Ticket is taken",
  ticketNotTaken: "Ticket is not taken",
  invalidPt: "Invalid PT",
  topupIdRequired: "Top up id required",
  promotionMemberLogNotExists: "promotion member log not exists",
  paymentOptionInactive: "Payment Option Inactive",
  invalidCartStatusFormat: "Invalid cart status format",
  requestIncompleted: 'Request Incompleted',
  unknownError: 'Unknown error occurred',
  cartIdRequired: "Cart ID is required",
  stepNameRequired: "Step name is required",
  invalidCart: "Invalid cart",
  invalidStepName: "Invalid step name",
  cartHaventSetupComplete: "Cart haven't setup complete",
  funcCartCreateFailed: "Failed to create cart",
  funcCartUpdateFailed: "Failed to update cart",
  funcSiteCreateFailed: "Failed to create site",
  funcCartPurchasedUpdateFailed: "Failed to update cart purchased",
  invalidPasswordFormat: "Invalid password format",
  currencyCodeRequired: "Currency is required",
  funcCartLanguageUpsertFailed: "Function Cart Language Upsert Failed",
  invalidUserIdFormat: "Invalid User ID Format",
  operatorPasswordRequired: "Operator Password is required",
  funcCartOperatorInfoUpsertFailed: "Function Cart Operator Info Upsert Failed",
  invalidOperatorPasswordFormat: "Invalid Operator Password Format",
  operatorIdCannotBeUse: "Operator ID cannot be used",
  siteNameLengthNotInRange: "Site Name length not in range",
  userIdCannotBeUse: "User ID cannot be used",
  siteIdAlrdExist: "Site ID already exists",
  operatorIdAlrdExist: "Operator ID already exists",
  externalIdAlrdExist: "External ID already exists",
  opsiteContentAlrdExist: "Site content theme content already exists",
  opsiteLanguageAlrdExist: "Site content language already exists",
  boAccountAlrdExist: "BO account already exists",
  boAccountProfileAlrdExist: "BO account profile already exists",
  boAccountLoginAlrdExist: "BO account login already exists",
  funcCartThemeCodeUpsertFailed: "Failed to upsert cart theme",
  funcCartThemeColorUpsertFailed: "Failed to upsert cart color",
  funcOpsiteCreateFailed: "Failed to create site content",
  alphabetValid: "Must have at least one uppercase and lowercase letter",
  numberValid: "Must have at least one number",
  symbolValid: "Must have at least one symbol",
  credentialNotSet: "Credential not set",
  validBankAccFormat: "Invalid Bank Acc No. Format",
  moreThan: "{fname} must be less than or equal to {fname2}",
  lessThan: "{fname} must be more than or equal to {fname2}.",
  bankAccountNotAvailable: "Bank account not available.",
  insufficientCredit: "Insufficient Credit",
  enableRequired: "Enable is required.",
  funcAddGameFailed: "Failed to add game.",
  funcAddGameRewardByBatchFailed: "Failed to add game reward by batch.",
  funcAddGameRewardFailed: "Failed to add game reward.",
  funcAddGameTemplateFailed: "Failed to add game template.",
  funcAddLayoutTemplateFailed: "Failed to add layout template.",
  funcAddOperatorGameFailed: "Failed to add operator game.",
  funcAddOperatorMemberWalletFailed: "Failed to add operator member wallet.",
  funcDeleteGameFailed: "Failed to delete game.",
  funcDeleteGameRewardFailed: "Failed to delete game reward.",
  funcDeleteGameTemplateFailed: "Failed to delete game template.",
  funcDeleteLayoutTemplateFailed: "Failed to delete layout template.",
  funcDeleteOperatorGameFailed: "Failed to delete operator game.",
  funcUpdateGameFailed: "Failed to update game.",
  funcUpdateGameRewardFailed: "Failed to update game reward.",
  funcUpdateGameTemplateFailed: "Failed to update game template.",
  funcUpdateLayoutTemplateFailed: "Failed to update layout template.",
  funcUpdateOperatorGameFailed: "Failed to update operator game.",
  gameCannotBeRemove: "Game cannot be removed.",
  gameNameCannotBeUse: "Game name cannot be used.",
  gameNameMaxLength150: "Game name must be at most 150 characters.",
  gameRewardCannotBeUse: "Game reward cannot be used.",
  gameRewardLimitExceeded: "Game reward limit exceeded.",
  gameTemplateExist: "Game template already exists.",
  gameTypeMaxLength20: "Game type must be at most 20 characters.",
  invalidGame: "Invalid game.",
  invalidGameReward: "Invalid game reward.",
  invalidGameTemplate: "Invalid game template.",
  invalidMemberWallet: "Invalid member wallet.",
  invalidOperatorGame: "Invalid operator game.",
  invalidRewardProbability: "Invalid reward probability.",
  invalidTemplate: "Invalid template.",
  maxGameRewardRequired: "Maximum game reward is required.",
  maxMiniGameRewardRequired: "Maximum mini-game reward is required.",
  memberWalletAlrdExist: "Member wallet already exists.",
  operatorGameCannotBeUse: "Operator game cannot be used.",
  operatorGameIdRequired: "Operator game ID is required.",
  rewardCodeMaxLength20: "Reward code must be at most 20 characters.",
  rewardCodeRequired: "Reward code is required.",
  rewardCurrencyMaxLength5: "Reward currency must be at most 5 characters.",
  rewardCurrencyRequired: "Reward currency is required.",
  rewardDescriptionMaxLength100: "Reward description must be at most 100 characters.",
  rewardNameMaxLength50: "Reward name must be at most 50 characters.",
  rewardProbabilityRequired: "Reward probability is required.",
  rewardRequired: "Reward is required.",
  selectedTemplateMaxLength30: "Selected template must be at most 30 characters.",
  selectedTemplateRequired: "Selected template is required.",
  success: "Success.",
  templateCannotBeRemove: "Template cannot be removed.",
  templateCodeCannotBeUse: "Template code cannot be used.",
  templateCodeMaxLength30: "Template code must be at most 30 characters.",
  templateCodeRequired: "Template code is required.",
  templateNameMaxLength50: "Template name must be at most 50 characters.",
  tokenRequestRequired: "Token request is required.",
  tokenRequired: "Token is required.",
  mustMoreThan: "{fname} must be more than {fvalue}",
  mustMoreThanOrEqual: "{fname} must be more than or equal to {fvalue}",
  tokenInvalid: 'Token input invalid at {key}',
  cashInvalid: 'Cash input invalid at {key}',
  atLeastOneRequired: 'At least one required',
  cash1To7Required: 'Cash 1 to 7 is required',
  cash1To6Required: 'Cash 1 to 6 is required',
  cash1To5Required: 'Cash 1 to 5 is required',
  cash1To4Required: 'Cash 1 to 4 is required',
  cash1To3Required: 'Cash 1 to 3 is required',
  cash1To2Required: 'Cash 1 to 2 is required',
  cash1Required: 'Cash 1 is required',
  token1To7Required: 'Token 1 to 7 is required',
  token1To6Required: 'Token 1 to 6 is required',
  token1To5Required: 'Token 1 to 5 is required',
  token1To4Required: 'Token 1 to 4 is required',
  token1To3Required: 'Token 1 to 3 is required',
  token1To2Required: 'Token 1 to 2 is required',
  token1Required: 'Token 1 is required',
  cycleRequired: 'Cycle is required',
  targetAmountRequired: 'Target amount is required',
  gamifyIdRequired: 'Reward ID is required',
  gamifyMemberProcessed: 'Reward member processed',
  gamifyNotExists: 'Reward not exists',
  gamifyInactive: 'Reward inactive',
  invalidCycle: 'Invalid Cycle',
  memberIdMaxLength50: "Member ID must not exceed 50 characters",
  funcAddGameWalletFreeCreditFailed: "Failed to add free credit to game wallet",
  funcUpdateOperatorMemberWalletBalanceFailed: "Failed to update operator member wallet balance",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "Failed to update operator member wallet balance by frozen amount",
  mustHaveBothAlphaNumOnly: "Use only alphabets and numbers, with at least one of each.",
  setupGameRewardBeforeEnable: "Please set up the game reward before enabling it.",
  rewardProbabilityMustNotAllZero: "Reward probabilities must not all be zero.",
  totalRewardProbabilityCannotOver100: "Total reward probability cannot exceed 100.",
  credential1To2Required: "Credential 1 to 2 is required.",
  credential1To4Required: "Credential 1 to 4 is required.",
  newRemarkRequired: "Remark is required.",

  notSupportedWithdrawalPG: "Non-supported withdrawal payment gateway.",
};